import React, { useState } from 'react' 
import './error.css' 
import Navbar from '../NavbarFooter/Navbar'
import Footer from '../NavbarFooter/Footer' 

function Errorpage(props) { 

  const [colorChange, setColorchange] = useState("");
  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(" rgb(70, 70, 70)");
    }
    else {
      setColorchange("");
    }
  };
  window.addEventListener('scroll', changeNavbarColor);
  return (
    <div className='mpBG'>
      <Navbar bgcolor={colorChange} />
      {/* <div className="navbar"></div> */}
 

      <div >
         
        <h1 className='myHero'>ERROR 404</h1>
         
      </div> 
      <Footer />
    </div>
  )
}

export default Errorpage